import { Fragment, SetStateAction, useState } from 'react'
import { useParams } from 'react-router-dom'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import { OnSubmit } from '../../../../../../forms/TwinForm/types'
import { TableInstanceType } from '../../../../../../baseComponents/TwinTable/types'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { CustomerModelType } from '@teinor/erp/types/company/customer'
import ModalEditTaskBagOfHours from '../../../../../ModalEditTaskBagOfHours'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import ModalCreateCustomerBagOfHours from '../../../CustomerBagOfHours/ModalCreateCustomerBagOfHours'
import { CustomerDashboardAddButton, CustomerDashboardSeeAllLink } from '../../SpecificComponents'
import { getUserPermissions } from '../../../../../../utils/reducers/getters'
import { TableCustomerBagsOfHours } from '../../../CustomerBagOfHours'

interface CustomerBagOfHoursDashboardProps extends CustomerBagOfHoursDashboardLogicProps {
    title: string
    allRowData: CustomerModelType
}

const CustomerBagOfHoursDashboard: React.FC<CustomerBagOfHoursDashboardProps> = ({ title, allRowData }) => {
    const { t } = useTwinTranslation()
    const { setTableInstance, tableInstance } = useCustomerBagOfHoursDashboardLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const userPermissions = getUserPermissions('customer.profile.bagOfHours')
    return (
        <div className='flex flex-col flex-auto gap-10'>
            <div className='flex flex-wrap justify-between gap-5'>
                <div className='flex items-center gap-x-10'>
                    <h3>{title}</h3>
                    <CustomerDashboardSeeAllLink customerTab='bagsOfHours' customerType={allRowData?.customer_type} />
                </div>
                <CustomerDashboardAddButton userPermissions={userPermissions || { n: 4, permission: 'delete' }} CreateModalComponent={ModalCreateCustomerBagOfHours} onSubmit={updateTableInstance} text={t('newBagOfHoursSmall', 'Nueva bolsa')} />
            </div>
            <TableCustomerBagOfHoursDashboard userPermissions={userPermissions || { n: 4, permission: 'delete' }} onSubmit={updateTableInstance} setTableInstance={setTableInstance} tableInstance={tableInstance} />
        </div>
    )
}

interface CustomerBagOfHoursDashboardLogicProps { }

const useCustomerBagOfHoursDashboardLogic = () => {
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    return { setTableInstance, tableInstance }
}

interface TableCustomerBagOfHoursDashboardProps extends ComponentWithPermissions {
    onSubmit: OnSubmit
    setTableInstance: React.Dispatch<SetStateAction<TableInstanceType>>
    tableInstance: TableInstanceType
}

const TableCustomerBagOfHoursDashboard: React.FC<TableCustomerBagOfHoursDashboardProps> = ({ onSubmit, setTableInstance, userPermissions, tableInstance }) => {
    const { id } = useParams()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <TableCustomerBagsOfHours name='CustomerBagOfHoursDashboard' className='small_simple_table' hideLoadFiltersButton={true} extraWhereParams={{ 'CustomerId': id }} setTableInstance={setTableInstance} setOpened={setOpenModal} tableInstance={tableInstance} userPermissions={userPermissions} />
            {openModal?.type === 'edit' && <ModalEditTaskBagOfHours {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} allRowData={openModal?.allRowData} basicData={{}} />}
        </Fragment>
    )
}

export default CustomerBagOfHoursDashboard